import { render, staticRenderFns } from "./mailVendeur.vue?vue&type=template&id=822c35f0&scoped=true&"
import script from "./mailVendeur.vue?vue&type=script&lang=js&"
export * from "./mailVendeur.vue?vue&type=script&lang=js&"
import style0 from "./mailVendeur.vue?vue&type=style&index=0&id=822c35f0&scoped=true&lang=scss&"
import style1 from "./mailVendeur.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822c35f0",
  null
  
)

export default component.exports